import { createAction, props } from '@ngrx/store';
import { EntityKey } from '@pma-entity/pma-entity-types';
import { Details } from '@details/Interfaces/details';

const tag = '[Details]';

export const loadDetails = createAction(
  `${tag} Load Details`,
  props<
  {
      id: string,
      entityName: string,
      key: EntityKey | undefined;
  }>());

export const loadDetailsComplete = createAction(
  `${tag} Load Details Complete`,
  props<
  {
      id: string,
      details: Details;
  }>());
